import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle, Loader2, ShieldAlert, ListChecks } from 'lucide-react';

const RESULT_STYLES = {
  success: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  denied: 'bg-red-100 text-red-800 border-red-200',
  error: 'bg-amber-100 text-amber-800 border-amber-200',
};

function McpAudit() {
  const [entries, setEntries] = useState([]);
  const [deniedLast24h, setDeniedLast24h] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/mcp-consent/audit/list?limit=200')
      .then((r) => {
        setEntries(r.data.entries || []);
        setDeniedLast24h(r.data.denied_last_24h || 0);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
      <div className="space-y-4" data-testid="mcp-audit-page">
        <div className="flex items-center gap-2">
          <ListChecks className="w-5 h-5 text-emerald-700" />
          <h1 className="text-lg font-semibold text-gray-900">Registro de auditoria</h1>
        </div>

        {deniedLast24h > 0 && (
          <div
            className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-4 flex items-center gap-3"
            data-testid="mcp-audit-denied-alert"
          >
            <ShieldAlert className="w-5 h-5 shrink-0" />
            <p className="text-sm">
              <strong>{deniedLast24h}</strong> tentativa(s) negada(s) nas últimas 24 horas (usuário
              incorreto, IP fora da lista, redirect inválido ou token inválido).
            </p>
          </div>
        )}

        <Card className="p-4">
          {loading ? (
            <div className="text-gray-500 text-sm flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Carregando...</div>
          ) : entries.length === 0 ? (
            <p className="text-gray-500 text-sm" data-testid="mcp-audit-empty">Nenhum evento registrado ainda.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="mcp-audit-table">
                <thead>
                  <tr className="text-left text-gray-500 border-b border-gray-100">
                    <th className="py-2 pr-4">Quando</th>
                    <th className="py-2 pr-4">Evento</th>
                    <th className="py-2 pr-4">Ferramenta</th>
                    <th className="py-2 pr-4">Resultado</th>
                    <th className="py-2 pr-4">IP</th>
                    <th className="py-2 pr-4">Itens</th>
                    <th className="py-2">Motivo</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((e, i) => (
                    <tr key={i} className="border-b border-gray-50">
                      <td className="py-2 pr-4 text-gray-500 whitespace-nowrap">{new Date(e.timestamp).toLocaleString('pt-BR')}</td>
                      <td className="py-2 pr-4">{e.event_type}</td>
                      <td className="py-2 pr-4 font-mono text-xs">{e.tool_name || '—'}</td>
                      <td className="py-2 pr-4">
                        <Badge className={`${RESULT_STYLES[e.result] || RESULT_STYLES.error} border`}>{e.result}</Badge>
                      </td>
                      <td className="py-2 pr-4 font-mono text-xs">{e.ip || '—'}</td>
                      <td className="py-2 pr-4">{e.item_count ?? '—'}</td>
                      <td className="py-2 text-gray-500">{e.reason || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      </div>
  );
}

export default McpAudit;
